import React, { useEffect, useState } from "react";
import { Button } from "../../../components/Button";
import ModalForm from "../../../components/ModalForm";

import { useSelector, useDispatch } from "react-redux";
import {
  resetFormData,
  setModal,
  getFormData,
  setFormData,
  submit,
} from "../../../stores/prod/prodDefaultTaskSlice";
import Select from "../../../components/Select";

import { getDataOptions as getDataOptionDepartment } from "../../../stores/master/departmentSlice";

function Form(props) {
  const { formType, dataId } = props;
  const dispatch = useDispatch();
  const openPopup = useSelector((state) => state.popup.openPopup);
  const openModal = useSelector((state) => state.prodDefaultTask.openModal);
  const formData = useSelector((state) => state.prodDefaultTask.formData);
  const dataOptionDepartment = useSelector(
    (state) => state.department.dataOptions
  );
  const [modalTitle, setModalTitle] = useState();

  useEffect(() => {
    dispatch(resetFormData());
    dispatch(getDataOptionDepartment());

    if (formType === "create") {
      setModalTitle("Add Default Task");
    } else {
      setModalTitle("Edit Default Task");
      dispatch(getFormData({ id: dataId }));
    }
  }, [dispatch, formType, dataId]);

  const handleInput = (e) => {
    dispatch(setFormData(e.target));
  };

  return (
    <>
      {!openPopup.open && openModal && (
        <ModalForm
          modalTitle={modalTitle}
          modalSize="small"
          closeModal={() => dispatch(setModal(false))}
        >
          <div className="w-full">
            <div className="form-group">
              <label className="control-label">
                Department <span className="text-danger">*</span>
              </label>
              <Select
                id="department_id"
                title="Department"
                name="department_id"
                placeholder={"Choose..."}
                defaultValue={dataOptionDepartment.filter(
                  (option) => option.value === formData.department_id
                )}
                onChange={(e) =>
                  dispatch(
                    setFormData({ name: "department_id", value: e?.value })
                  )
                }
                options={dataOptionDepartment}
                required={true}
              />
            </div>
            <div className="form-group">
              <label className="control-label">
                Task Name <span className="text-danger">*</span>
              </label>
              <input
                id="task_name"
                title="Task Name"
                type="text"
                name="task_name"
                className="form-control"
                value={formData.task_name}
                onChange={handleInput}
                required
              />
            </div>
          </div>

          <div className="mt-8 flex gap-2">
            <Button
              title="Save"
              icon="BiSave"
              color="primary"
              onClick={() => dispatch(submit({ formType: formType }))}
            />
            <Button
              title="Cancel"
              icon="BiX"
              color="secondary"
              onClick={() => dispatch(setModal(false))}
            />
          </div>
        </ModalForm>
      )}
    </>
  );
}

export default Form;
